export function signInRequest(data) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: data,
  };
}

export function signInSuccess(order) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { order },
  };
}

export function signInFailure(message = "") {
  return {
    type: '@auth/SIGN_FAILURE',
    payload: { message }
  };
}
